(() => {
  const controls = document.querySelector('[data-cps-guides-source]');
  const grid = document.querySelector('[data-cps-guide-grid]');
  const button = controls?.querySelector('[data-cps-guides-more]');
  const status = controls?.querySelector('[data-cps-guides-status]');
  if (!controls || !grid || !button || !status) return;

  const source = new URL(controls.dataset.cpsGuidesSource, window.location.origin);
  const seen = new Set([...grid.querySelectorAll('.blog-card-v27__media[href]')].map(link => new URL(link.href).pathname));
  const visited = new Set();
  let nextUrl = source.href;
  let pending = [];
  let loading = false;

  async function fetchNextPage() {
    if (!nextUrl || visited.has(nextUrl)) {
      nextUrl = null;
      return;
    }
    const url = nextUrl;
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`Guide listing returned ${response.status}`);
    const html = await response.text();
    const documentPage = new DOMParser().parseFromString(html, 'text/html');
    const cards = [...documentPage.querySelectorAll('#browse-repair-guides .coconix-blog-v2__grid > .blog-card-v27__grid-item')];
    if (!cards.length) throw new Error('No guide cards were found in the guide listing');
    visited.add(url);
    pending.push(...cards);
    const nextLink = documentPage.querySelector('#browse-repair-guides .coconix-blog-v2__pagination .next a[href]');
    const candidate = nextLink ? new URL(nextLink.getAttribute('href'), source.origin) : null;
    nextUrl = candidate && candidate.origin === source.origin && candidate.pathname === source.pathname && !visited.has(candidate.href) ? candidate.href : null;
  }

  button.addEventListener('click', async () => {
    if (loading) return;
    loading = true;
    button.disabled = true;
    button.textContent = 'Loading guides…';
    try {
      let added = 0;
      while (added < 4 && (pending.length || nextUrl)) {
        if (!pending.length) await fetchNextPage();
        const card = pending.shift();
        if (!card) continue;
        const link = card.querySelector('.blog-card-v27__media[href]');
        if (!link) continue;
        const path = new URL(link.getAttribute('href'), source.origin).pathname;
        if (seen.has(path)) continue;
        seen.add(path);
        grid.appendChild(document.importNode(card, true));
        added += 1;
      }
      status.textContent = added ? `Showing ${grid.querySelectorAll('.blog-card-v27__grid-item').length} repair guides.` : 'All matching repair guides are shown.';
      if (!pending.length && !nextUrl) button.hidden = true;
    } catch (error) {
      status.textContent = 'More guides could not load. Please try again or use View all repair guides.';
    } finally {
      loading = false;
      button.disabled = false;
      button.textContent = 'Show more repair guides';
    }
  });
})();
